import type { Tool } from '../tools/tools.typing'

export const nonNavigableVariableToolProps: Pick<Tool, 'path' | 'restrictView'> = {
  path: '',
  restrictView: [],
}

export function getRankedVariableRelevance(
  index: number,
  {
    initial = 0.6,
    step = 0.01,
    minimum = 0.15,
  }: {
    initial?: number
    step?: number
    minimum?: number
  } = {},
) {
  return Math.max(minimum, initial - index * step)
}
